/* TenantSignature — small rotated 90° "POWERED BY LUMETIER" credit pinned
   to the lower-right of every tenant template page (a quiet wayfinding
   signal that the tenant's site is part of the Lumetier network).

   Companion piece: LumetierFooterCredit (inline footer text link). Both
   respect the same `lumetier_credit_hidden` toggle from site_settings —
   today free for any tenant to toggle on, but flagged as a "paid-plan
   feature" in the admin UI ahead of Stripe billing going live.

   UTM-tagged so attribution from tenant → Lumetier shows up cleanly in
   GA. We keep the URL itself short (no slug content) so the rendered
   string stays compact at 9px. */

import React from "react";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export const LUMETIER_HREF =
  "https://lumetiercreatives.com/?utm_source=tenant&utm_medium=footer&utm_campaign=powered_by_lumetier";

export default function TenantSignature({ tone = "auto" }) {
  const { settings } = useSiteSettings();
  if (settings?.lumetier_credit_hidden) return null;
  // auto = transparent on light backgrounds, muted gold on dark.
  const color =
    tone === "dark"
      ? "rgba(250, 249, 246, 0.45)"
      : tone === "light"
        ? "rgba(14, 13, 12, 0.40)"
        : "var(--tenant-accent, #C9A961)";
  return (
    <a
      href={LUMETIER_HREF}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="tenant-lumetier-signature"
      className="fixed right-3 lg:right-4 bottom-24 lg:bottom-32 z-30 select-none transition-opacity duration-300 hover:opacity-100"
      style={{
        writingMode: "vertical-rl",
        textOrientation: "mixed",
        transform: "rotate(180deg)",
        fontSize: "9px",
        letterSpacing: "0.38em",
        textTransform: "uppercase",
        color,
        opacity: 0.55,
      }}
    >
      <span style={{ fontFamily: "var(--tenant-sans, 'Manrope', sans-serif)" }}>
        Powered by <span style={{ fontStyle: "italic", fontFamily: "var(--tenant-serif, 'Cormorant Garamond', serif)", textTransform: "none", letterSpacing: "0.02em" }}>Lumetier</span>
      </span>
    </a>
  );
}
